interface Properties {
  status: 'success' | 'error';
  size?: number;
  color?: string;
}

/** Solid colored circle with a white stroke check (success) or cross (error) — used across all toasts. */
const ToastStatusIcon = ({ status, size = 22, color }: Properties) => {
  const fill = color || (status === 'error' ? '#FE552F' : '#22C55E');
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 22 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='11' cy='11' r='11' fill={fill} />
      {status === 'error' ? (
        <path
          d='M8 8L14 14M14 8L8 14'
          stroke='white'
          strokeWidth='1.8'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      ) : (
        <path
          d='M7 11.2L9.8 14L15 8.5'
          stroke='white'
          strokeWidth='1.8'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      )}
    </svg>
  );
};

export default ToastStatusIcon;
